import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountRoutingModule } from './account-routing.module';
import { AccountLayoutComponent } from './containers/account-layout/account-layout.component';
import { AccountProfileEditComponent } from './containers/account-profile-edit/account-profile-edit.component';
import { AccountProfileComponent } from './containers/account-profile/account-profile.component';
import { DynamicFormModule } from '@teamfoster/dynamic-forms';
import { CoreModule } from '../core/core.module';
import { DictionaryNgrxModule } from '@teamfoster/sdk/dictionary-ngrx';
import { ProfileCardComponent } from './components/profile-card/profile-card.component';
import { AccountOrderOverviewComponent } from './containers/account-order-overview/account-order-overview.component';
import { OrderListItemComponent } from './components/order-list-item/order-list-item.component';
import { AccountOrderDetailComponent } from './containers/account-order-detail/account-order-detail.component';
import { OrderProductListItemComponent } from './components/order-product-list-item/order-product-list-item.component';
import { InViewModule } from '@teamfoster/sdk/in-view';
import { ShopModule } from '../shop/shop.module';
import { AddressCardComponent } from './components/address-card/address-card.component';
import { AccountEditAddressesComponent } from './containers/account-edit-addresses/account-edit-addresses.component';
import { MatDialogModule } from '@angular/material/dialog';
import { FulfillmentStatusBarComponent } from './components/fulfillment-status-bar/fulfillment-status-bar.component';
import { OrderAgainDialogComponent } from './components/order-again-dialog/order-again-dialog.component';
import { CatalogModule } from '../catalog/catalog.module';

const moduleExports = [AddressCardComponent];
@NgModule({
  declarations: [
    AccountLayoutComponent,
    AccountProfileEditComponent,
    AccountProfileComponent,
    ProfileCardComponent,
    AccountOrderOverviewComponent,
    OrderListItemComponent,
    AccountOrderDetailComponent,
    OrderProductListItemComponent,
    AccountEditAddressesComponent,
    ...moduleExports,
    OrderAgainDialogComponent,
    FulfillmentStatusBarComponent,
  ],
  imports: [
    CommonModule,
    CoreModule,
    DictionaryNgrxModule,
    AccountRoutingModule,
    DynamicFormModule,
    InViewModule,
    ShopModule,
    MatDialogModule,
    CatalogModule,
  ],
  exports: [...moduleExports],
})
export class AccountModule {}
